import clsx from "clsx"
import Button from "components/EvtKit/button/Button"
import BodyText from "components/Typography/BodyText"
import { memo, useMemo } from "react"
import { IoMdAddCircleOutline } from "react-icons/io"
import styled from "styled-components"
import { Colors } from "themes/palette"

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 48px 24px 0px 44px;
  height: 540px;
  width: 90%;
  background-color: ${Colors.white_alt_soft};
  box-shadow: 0px 2px 10px 0px ${Colors.black_alt_soft};
  border-radius: 12px;
`
const ContainerBox = styled.div`
  display: grid;
  gap: 60px;
  justify-items: center;
  align-items: center;
`

interface Props {
  openCreateModal: () => void
  filterValue: string
}
const Board = (props: Props) => {
  const { openCreateModal, filterValue } = props

  const label = useMemo(() => {
    if (filterValue) return "Você ainda não criou nenhum Tipo de Evento para esse produto"

    return "Você ainda não criou nenhum Tipo de Evento"
  }, [filterValue])

  return (
    <Container>
      <ContainerBox>
        <BodyText weight="semi-bold" size="medium" color="gray-dark">
          {label}
        </BodyText>
        <Button
          onClick={openCreateModal}
          iconLeft={<IoMdAddCircleOutline size={24} color={Colors.white} />}
          label="Criar novo Tipo de Evento"
          className={clsx("background-gradient")}
        />
      </ContainerBox>
    </Container>
  )
}

export default memo(Board)
